export default "__VITE_ASSET__BwKmwnC5__"